import { render, staticRenderFns } from "./SiteCardTag.vue?vue&type=template&id=d5678b56&scoped=true&"
import script from "./SiteCardTag.vue?vue&type=script&lang=ts&"
export * from "./SiteCardTag.vue?vue&type=script&lang=ts&"
import style0 from "./SiteCardTag.vue?vue&type=style&index=0&id=d5678b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5678b56",
  null
  
)

export default component.exports